export default __webpack_public_path__ + "static/media/dunes.2fdd79d8.jpg";